import { Grid, Button } from "@mui/material";
import { useState } from "react";
import { deleteRequest } from "../../../../Service/ApiService";
import formatingTime from "../../../ShareFonction/FormattingTime";
import DeleteRequest from "../../Modal/DeleteRequest";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";

const ListOfButtonsProject = (props: any) => {
  const [deleteRequestConfirmation, setDeleteRequestConfirmation] =
    useState(false);
  const closeDeleteRequest = () => {
    setDeleteRequestConfirmation(false);
  };
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  const confirmDeleteRequest = () => {
    const centerName: string[] = [];
    const centers = props.requestData.globalInformations.center.map(
      (center: any) => {
        if (center.state === "accepted" || center.state === "acceptedIf")
          centerName.push(center.center);
        return center.id;
      }
    );
    const time = formatingTime(
      props.requestData.specificInformations,
      props.requestData.globalInformations.flightType
    );
    deleteRequest(
      props.requestData.id,
      centers,
      props.requestData.globalInformations.applicantName,
      props.requestData.globalInformations.reference,
      time,
      centerName
    )
      .then(() => {
        enqueueSnackbar(t("project.deleteProject"), {
          variant: "success",
        });
        setDeleteRequestConfirmation(false);
        props.reSubmitRequest();
      })
      .catch((error) => {
        enqueueSnackbar(t("error.errorHasOccured"), {
          variant: "error",
        });
        console.error(error);
      });
  };

  return (
    <>
      <Grid
        container
        alignItems="center"
        alignContent="center"
        justifyContent="center"
      >
        <Button
          variant="contained"
          size="small"
          onClick={() => {
            props.selectSubmitWithModification();
          }}
          style={{ marginRight: "10px" }}
        >
          {t("request.newRequest")}
        </Button>

        <Button
          variant="contained"
          size="small"
          color="primary"
          style={{ marginRight: "10px" }}
          onClick={() => {
            props.updateRequest();
          }}
        >
          {t("global.update")}
        </Button>
        <Button
          variant="contained"
          size="small"
          color="error"
          onClick={() => {
            setDeleteRequestConfirmation(true);
          }}
        >
          {t("global.delete")}
        </Button>
      </Grid>
      <DeleteRequest
        open={deleteRequestConfirmation}
        closeModal={closeDeleteRequest}
        confirmDeleteRequest={confirmDeleteRequest}
      />
    </>
  );
};

export default ListOfButtonsProject;
